import React, { FC } from 'react'
import { UISizes, BtnComponent, i18n } from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'

interface ComponentProps {
	title: string
	action: Callback
}

export const NotificationPopupFooterComponent: FC<ComponentProps> = ({ title, action }) => {
	return <BtnComponent size={UISizes.SMALL} title={i18n(title)} outline onClick={() => action()} />
}
